import { gsap, Power2 } from 'gsap';
import { Flip } from 'gsap/Flip';

gsap.registerPlugin(Flip);

export function useFlying(cart) {
    const fly = (item) => {
        if (!item || !cart?.current) return;

        const state = Flip.getState(item, { props: 'width' });
        cart.current.appendChild(item);
        Flip.from(state, {
            duration: 0.8,
            scale: true,
            absolute: true,
            ease: Power2.easeIn,
            onComplete: () => {
                cart.current.removeChild(item);
                gsap.fromTo(
                    cart.current,
                    { scale: 1.3 },
                    { scale: 1, clearProps: 'all' }
                );
            },
            zIndex: 2000,
        });
    };

    return fly;
}
